// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as Js_exn from "rescript/lib/es6/js_exn.js";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Js_json from "rescript/lib/es6/js_json.js";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Pervasives from "rescript/lib/es6/pervasives.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Belt_Result from "rescript/lib/es6/belt_Result.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Caml_js_exceptions from "rescript/lib/es6/caml_js_exceptions.js";

function mapError(result, fn) {
  if (result.TAG === /* Ok */0) {
    return result;
  } else {
    return {
            TAG: /* Error */1,
            _0: Curry._1(fn, result._0)
          };
  }
}

function sequence(results) {
  return Belt_Array.reduce(results, {
              TAG: /* Ok */0,
              _0: []
            }, (function (maybeAcc, res) {
                return Belt_Result.flatMap(maybeAcc, (function (acc) {
                              return Belt_Result.map(res, (function (x) {
                                            return Belt_Array.concat(acc, [x]);
                                          }));
                            }));
              }));
}

function formatLocation($$location) {
  return "." + Belt_Array.map($$location, (function (s) {
                  if (s.TAG === /* Field */0) {
                    return "\"" + s._0 + "\"";
                  } else {
                    return "[" + String(s._0) + "]";
                  }
                })).join(".");
}

function prependLocation(err, loc) {
  var variant = err.NAME;
  if (variant === "MissingField") {
    var match = err.VAL;
    var location$p = Belt_Array.concat([loc], match[0]);
    return {
            NAME: "MissingField",
            VAL: [
              location$p,
              match[1]
            ]
          };
  }
  if (variant === "SyntaxError") {
    return err;
  }
  if (variant === "UnexpectedJsonType") {
    var match$1 = err.VAL;
    var location$p$1 = Belt_Array.concat([loc], match$1[0]);
    return {
            NAME: "UnexpectedJsonType",
            VAL: [
              location$p$1,
              match$1[1],
              match$1[2]
            ]
          };
  }
  var match$2 = err.VAL;
  var location$p$2 = Belt_Array.concat([loc], match$2[0]);
  return {
          NAME: "UnexpectedJsonValue",
          VAL: [
            location$p$2,
            match$2[1]
          ]
        };
}

function toString(err) {
  var variant = err.NAME;
  if (variant === "MissingField") {
    var match = err.VAL;
    return "Missing field \"" + match[1] + "\" at " + formatLocation(match[0]);
  }
  if (variant === "SyntaxError") {
    return err.VAL;
  }
  if (variant === "UnexpectedJsonType") {
    var match$1 = err.VAL;
    var match$2 = Js_json.classify(match$1[2]);
    var actualType;
    if (typeof match$2 === "number") {
      switch (match$2) {
        case /* JSONFalse */0 :
        case /* JSONTrue */1 :
            actualType = "boolean";
            break;
        case /* JSONNull */2 :
            actualType = "null";
            break;
        
      }
    } else {
      switch (match$2.TAG | 0) {
        case /* JSONString */0 :
            actualType = "string";
            break;
        case /* JSONNumber */1 :
            actualType = "number";
            break;
        case /* JSONObject */2 :
            actualType = "object";
            break;
        case /* JSONArray */3 :
            actualType = "array";
            break;
        
      }
    }
    return "Expected " + match$1[1] + ", got " + actualType + " at " + formatLocation(match$1[0]);
  }
  var match$3 = err.VAL;
  return "Unexpected value " + match$3[1] + " at " + formatLocation(match$3[0]);
}

function make(encode, decode) {
  return {
          encode: encode,
          decode: decode
        };
}

function encode(codec) {
  return codec.encode;
}

function encodeString(codec, value) {
  return JSON.stringify(Curry._1(codec.encode, value));
}

function decode(codec) {
  return codec.decode;
}

function decodeString(codec, str) {
  var maybeJson;
  var exit = 0;
  var json;
  try {
    json = JSON.parse(str);
    exit = 1;
  }
  catch (raw_obj){
    var obj = Caml_js_exceptions.internalToOCamlException(raw_obj);
    if (obj.RE_EXN_ID === Js_exn.$$Error) {
      var message = obj._1.message;
      maybeJson = {
        TAG: /* Error */1,
        _0: {
          NAME: "SyntaxError",
          VAL: Belt_Option.getWithDefault(message, "Syntax error")
        }
      };
    } else {
      throw obj;
    }
  }
  if (exit === 1) {
    maybeJson = {
      TAG: /* Ok */0,
      _0: json
    };
  }
  return Belt_Result.flatMap(maybeJson, (function (json) {
                return Curry._1(codec.decode, json);
              }));
}

function identity_encode(x) {
  return x;
}

function identity_decode(x) {
  return {
          TAG: /* Ok */0,
          _0: x
        };
}

var identity = {
  encode: identity_encode,
  decode: identity_decode
};

function encodeWith(data, codec) {
  return Curry._1(codec.encode, data);
}

function encodeStringWith(data, codec) {
  return encodeString(codec, data);
}

function decodeWith(json, codec) {
  return Curry._1(codec.decode, json);
}

function decodeStringWith(string, codec) {
  return decodeString(codec, string);
}

function string_encode(prim) {
  return prim;
}

function string_decode(json) {
  var x = Js_json.decodeString(json);
  if (x !== undefined) {
    return {
            TAG: /* Ok */0,
            _0: x
          };
  } else {
    return {
            TAG: /* Error */1,
            _0: {
              NAME: "UnexpectedJsonType",
              VAL: [
                [],
                "string",
                json
              ]
            }
          };
  }
}

var string = {
  encode: string_encode,
  decode: string_decode
};

function float_encode(prim) {
  return prim;
}

function float_decode(json) {
  var x = Js_json.decodeNumber(json);
  if (x !== undefined) {
    return {
            TAG: /* Ok */0,
            _0: x
          };
  } else {
    return {
            TAG: /* Error */1,
            _0: {
              NAME: "UnexpectedJsonType",
              VAL: [
                [],
                "number",
                json
              ]
            }
          };
  }
}

var $$float = {
  encode: float_encode,
  decode: float_decode
};

var int_encode = Curry.__1(float_encode);

function int_decode(json) {
  return Belt_Result.flatMap(Curry._1(float_decode, json), (function (x) {
                if (x === Math.trunc(x) && x >= -2147483648 && x <= 2147483647) {
                  return {
                          TAG: /* Ok */0,
                          _0: Math.trunc(x)
                        };
                } else {
                  return {
                          TAG: /* Error */1,
                          _0: {
                            NAME: "UnexpectedJsonValue",
                            VAL: [
                              [],
                              String(x)
                            ]
                          }
                        };
                }
              }));
}

var $$int = {
  encode: int_encode,
  decode: int_decode
};

function bool_encode(prim) {
  return prim;
}

function bool_decode(json) {
  var x = Js_json.decodeBoolean(json);
  if (x !== undefined) {
    return {
            TAG: /* Ok */0,
            _0: x
          };
  } else {
    return {
            TAG: /* Error */1,
            _0: {
              NAME: "UnexpectedJsonType",
              VAL: [
                [],
                "bool",
                json
              ]
            }
          };
  }
}

var bool = {
  encode: bool_encode,
  decode: bool_decode
};

function nullable(payloadCodec) {
  return {
          encode: (function (maybeValue) {
              if (maybeValue !== undefined) {
                return Curry._1(payloadCodec.encode, Caml_option.valFromOption(maybeValue));
              } else {
                return null;
              }
            }),
          decode: (function (json) {
              if (Caml_obj.caml_equal(json, null)) {
                return {
                        TAG: /* Ok */0,
                        _0: undefined
                      };
              } else {
                return Belt_Result.map(Curry._1(payloadCodec.decode, json), (function (v) {
                              return Caml_option.some(v);
                            }));
              }
            })
        };
}

function nullAs(payloadCodec, fallbackValue) {
  return {
          encode: (function (value) {
              return Curry._1(payloadCodec.encode, value);
            }),
          decode: (function (json) {
              if (Caml_obj.caml_equal(json, null)) {
                return {
                        TAG: /* Ok */0,
                        _0: fallbackValue
                      };
              } else {
                return Curry._1(payloadCodec.decode, json);
              }
            })
        };
}

function array(elementCodec) {
  return {
          encode: (function (xs) {
              return Belt_Array.map(xs, elementCodec.encode);
            }),
          decode: (function (json) {
              var elementJsons = Js_json.classify(json);
              if (typeof elementJsons !== "number" && elementJsons.TAG === /* JSONArray */3) {
                return sequence(Belt_Array.mapWithIndex(elementJsons._0, (function (i, elemJson) {
                                  return mapError(Curry._1(elementCodec.decode, elemJson), (function (__x) {
                                                return prependLocation(__x, {
                                                            TAG: /* Index */1,
                                                            _0: i
                                                          });
                                              }));
                                })));
              }
              return {
                      TAG: /* Error */1,
                      _0: {
                        NAME: "UnexpectedJsonType",
                        VAL: [
                          [],
                          "array",
                          json
                        ]
                      }
                    };
            })
        };
}

function asObject(json) {
  var fieldset = Js_json.classify(json);
  if (typeof fieldset !== "number" && fieldset.TAG === /* JSONObject */2) {
    return {
            TAG: /* Ok */0,
            _0: fieldset._0
          };
  }
  return {
          TAG: /* Error */1,
          _0: {
            NAME: "UnexpectedJsonType",
            VAL: [
              [],
              "object",
              json
            ]
          }
        };
}

function dict(valuesCodec) {
  return {
          encode: (function (dict) {
              return Js_dict.map((function (val) {
                            return Curry._1(valuesCodec.encode, val);
                          }), dict);
            }),
          decode: (function (json) {
              return Belt_Result.flatMap(asObject(json), (function (obj) {
                            var match = Belt_Array.unzip(Belt_Array.map(Js_dict.entries(obj), (function (param) {
                                        var key = param[0];
                                        return [
                                                key,
                                                mapError(Curry._1(valuesCodec.decode, param[1]), (function (__x) {
                                                        return prependLocation(__x, {
                                                                    TAG: /* Field */0,
                                                                    _0: key
                                                                  });
                                                      }))
                                              ];
                                      })));
                            var keys = match[0];
                            return Belt_Result.map(sequence(match[1]), (function (vals) {
                                          return Js_dict.fromArray(Belt_Array.zip(keys, vals));
                                        }));
                          }));
            })
        };
}

function makeOptional(param) {
  return {
          path: param.path,
          codec: nullable(param.codec),
          claim: /* Optional */1
        };
}

function assignDefault(param, value) {
  return {
          path: param.path,
          codec: nullAs(param.codec, value),
          claim: /* OptionalWithDefault */{
            _0: value
          }
        };
}

function path(param) {
  return param.path;
}

function codec(param) {
  return param.codec;
}

function claim(param) {
  return param.claim;
}

function encode$1(field, val) {
  var key = path(field);
  if (key) {
    var json = Curry._1(codec(field).encode, val);
    if (Caml_obj.caml_equal(json, null) && claim(field) === /* Optional */1) {
      return [];
    } else {
      return [[
                key._0,
                json
              ]];
    }
  }
  var objDict = Js_json.classify(Curry._1(codec(field).encode, val));
  if (typeof objDict === "number" || objDict.TAG !== /* JSONObject */2) {
    return Pervasives.failwith("Field `self` must be encoded as object");
  } else {
    return Js_dict.entries(objDict._0);
  }
}

function decode$1(field, fieldset) {
  var key = path(field);
  if (!key) {
    return Curry._1(codec(field).decode, fieldset);
  }
  var key$1 = key._0;
  var decodeChild = function (childJson) {
    return mapError(Curry._1(codec(field).decode, childJson), (function (__x) {
                  return prependLocation(__x, {
                              TAG: /* Field */0,
                              _0: key$1
                            });
                }));
  };
  var match = Js_dict.get(fieldset, key$1);
  var match$1 = claim(field);
  if (match !== undefined) {
    return decodeChild(Caml_option.valFromOption(match));
  } else if (typeof match$1 === "number") {
    if (match$1 !== 0) {
      return decodeChild(null);
    } else {
      return {
              TAG: /* Error */1,
              _0: {
                NAME: "MissingField",
                VAL: [
                  [],
                  key$1
                ]
              }
            };
    }
  } else {
    return {
            TAG: /* Ok */0,
            _0: match$1._0
          };
  }
}

function field(key, codec) {
  return {
          path: /* Key */{
            _0: key
          },
          codec: codec,
          claim: /* Required */0
        };
}

var self = {
  path: /* Self */0,
  codec: identity,
  claim: /* Required */0
};

function object1(destruct, construct, field1) {
  return {
          encode: (function (value) {
              var val1 = Curry._1(destruct, value);
              var keyVals = [encode$1(field1, val1)];
              return Js_dict.fromArray(Belt_Array.concatMany(keyVals));
            }),
          decode: (function (json) {
              return Belt_Result.flatMap(asObject(json), (function (fieldset) {
                            var val1 = decode$1(field1, fieldset);
                            if (val1.TAG === /* Ok */0) {
                              return Curry._1(construct, val1._0);
                            } else {
                              return val1;
                            }
                          }));
            })
        };
}

function object2(destruct, construct, field1, field2) {
  return {
          encode: (function (value) {
              var match = Curry._1(destruct, value);
              var keyVals = [
                encode$1(field1, match[0]),
                encode$1(field2, match[1])
              ];
              return Js_dict.fromArray(Belt_Array.concatMany(keyVals));
            }),
          decode: (function (json) {
              return Belt_Result.flatMap(asObject(json), (function (fieldset) {
                            var val1 = decode$1(field1, fieldset);
                            if (val1.TAG !== /* Ok */0) {
                              return val1;
                            }
                            var val2 = decode$1(field2, fieldset);
                            if (val2.TAG === /* Ok */0) {
                              return Curry._1(construct, [
                                          val1._0,
                                          val2._0
                                        ]);
                            } else {
                              return val2;
                            }
                          }));
            })
        };
}

function object3(destruct, construct, field1, field2, field3) {
  return {
          encode: (function (value) {
              var match = Curry._1(destruct, value);
              var keyVals = [
                encode$1(field1, match[0]),
                encode$1(field2, match[1]),
                encode$1(field3, match[2])
              ];
              return Js_dict.fromArray(Belt_Array.concatMany(keyVals));
            }),
          decode: (function (json) {
              return Belt_Result.flatMap(asObject(json), (function (fieldset) {
                            var val1 = decode$1(field1, fieldset);
                            if (val1.TAG !== /* Ok */0) {
                              return val1;
                            }
                            var val2 = decode$1(field2, fieldset);
                            if (val2.TAG !== /* Ok */0) {
                              return val2;
                            }
                            var val3 = decode$1(field3, fieldset);
                            if (val3.TAG === /* Ok */0) {
                              return Curry._1(construct, [
                                          val1._0,
                                          val2._0,
                                          val3._0
                                        ]);
                            } else {
                              return val3;
                            }
                          }));
            })
        };
}

function object4(destruct, construct, field1, field2, field3, field4) {
  return {
          encode: (function (value) {
              var match = Curry._1(destruct, value);
              var keyVals = [
                encode$1(field1, match[0]),
                encode$1(field2, match[1]),
                encode$1(field3, match[2]),
                encode$1(field4, match[3])
              ];
              return Js_dict.fromArray(Belt_Array.concatMany(keyVals));
            }),
          decode: (function (json) {
              return Belt_Result.flatMap(asObject(json), (function (fieldset) {
                            var val1 = decode$1(field1, fieldset);
                            if (val1.TAG !== /* Ok */0) {
                              return val1;
                            }
                            var val2 = decode$1(field2, fieldset);
                            if (val2.TAG !== /* Ok */0) {
                              return val2;
                            }
                            var val3 = decode$1(field3, fieldset);
                            if (val3.TAG !== /* Ok */0) {
                              return val3;
                            }
                            var val4 = decode$1(field4, fieldset);
                            if (val4.TAG === /* Ok */0) {
                              return Curry._1(construct, [
                                          val1._0,
                                          val2._0,
                                          val3._0,
                                          val4._0
                                        ]);
                            } else {
                              return val4;
                            }
                          }));
            })
        };
}

function object5(destruct, construct, field1, field2, field3, field4, field5) {
  return {
          encode: (function (value) {
              var match = Curry._1(destruct, value);
              var keyVals = [
                encode$1(field1, match[0]),
                encode$1(field2, match[1]),
                encode$1(field3, match[2]),
                encode$1(field4, match[3]),
                encode$1(field5, match[4])
              ];
              return Js_dict.fromArray(Belt_Array.concatMany(keyVals));
            }),
          decode: (function (json) {
              return Belt_Result.flatMap(asObject(json), (function (fieldset) {
                            var val1 = decode$1(field1, fieldset);
                            if (val1.TAG !== /* Ok */0) {
                              return val1;
                            }
                            var val2 = decode$1(field2, fieldset);
                            if (val2.TAG !== /* Ok */0) {
                              return val2;
                            }
                            var val3 = decode$1(field3, fieldset);
                            if (val3.TAG !== /* Ok */0) {
                              return val3;
                            }
                            var val4 = decode$1(field4, fieldset);
                            if (val4.TAG !== /* Ok */0) {
                              return val4;
                            }
                            var val5 = decode$1(field5, fieldset);
                            if (val5.TAG === /* Ok */0) {
                              return Curry._1(construct, [
                                          val1._0,
                                          val2._0,
                                          val3._0,
                                          val4._0,
                                          val5._0
                                        ]);
                            } else {
                              return val5;
                            }
                          }));
            })
        };
}

function object6(destruct, construct, field1, field2, field3, field4, field5, field6) {
  return {
          encode: (function (value) {
              var match = Curry._1(destruct, value);
              var keyVals = [
                encode$1(field1, match[0]),
                encode$1(field2, match[1]),
                encode$1(field3, match[2]),
                encode$1(field4, match[3]),
                encode$1(field5, match[4]),
                encode$1(field6, match[5])
              ];
              return Js_dict.fromArray(Belt_Array.concatMany(keyVals));
            }),
          decode: (function (json) {
              return Belt_Result.flatMap(asObject(json), (function (fieldset) {
                            var val1 = decode$1(field1, fieldset);
                            if (val1.TAG !== /* Ok */0) {
                              return val1;
                            }
                            var val2 = decode$1(field2, fieldset);
                            if (val2.TAG !== /* Ok */0) {
                              return val2;
                            }
                            var val3 = decode$1(field3, fieldset);
                            if (val3.TAG !== /* Ok */0) {
                              return val3;
                            }
                            var val4 = decode$1(field4, fieldset);
                            if (val4.TAG !== /* Ok */0) {
                              return val4;
                            }
                            var val5 = decode$1(field5, fieldset);
                            if (val5.TAG !== /* Ok */0) {
                              return val5;
                            }
                            var val6 = decode$1(field6, fieldset);
                            if (val6.TAG === /* Ok */0) {
                              return Curry._1(construct, [
                                          val1._0,
                                          val2._0,
                                          val3._0,
                                          val4._0,
                                          val5._0,
                                          val6._0
                                        ]);
                            } else {
                              return val6;
                            }
                          }));
            })
        };
}

function object7(destruct, construct, field1, field2, field3, field4, field5, field6, field7) {
  return {
          encode: (function (value) {
              var match = Curry._1(destruct, value);
              var keyVals = [
                encode$1(field1, match[0]),
                encode$1(field2, match[1]),
                encode$1(field3, match[2]),
                encode$1(field4, match[3]),
                encode$1(field5, match[4]),
                encode$1(field6, match[5]),
                encode$1(field7, match[6])
              ];
              return Js_dict.fromArray(Belt_Array.concatMany(keyVals));
            }),
          decode: (function (json) {
              return Belt_Result.flatMap(asObject(json), (function (fieldset) {
                            var val1 = decode$1(field1, fieldset);
                            if (val1.TAG !== /* Ok */0) {
                              return val1;
                            }
                            var val2 = decode$1(field2, fieldset);
                            if (val2.TAG !== /* Ok */0) {
                              return val2;
                            }
                            var val3 = decode$1(field3, fieldset);
                            if (val3.TAG !== /* Ok */0) {
                              return val3;
                            }
                            var val4 = decode$1(field4, fieldset);
                            if (val4.TAG !== /* Ok */0) {
                              return val4;
                            }
                            var val5 = decode$1(field5, fieldset);
                            if (val5.TAG !== /* Ok */0) {
                              return val5;
                            }
                            var val6 = decode$1(field6, fieldset);
                            if (val6.TAG !== /* Ok */0) {
                              return val6;
                            }
                            var val7 = decode$1(field7, fieldset);
                            if (val7.TAG === /* Ok */0) {
                              return Curry._1(construct, [
                                          val1._0,
                                          val2._0,
                                          val3._0,
                                          val4._0,
                                          val5._0,
                                          val6._0,
                                          val7._0
                                        ]);
                            } else {
                              return val7;
                            }
                          }));
            })
        };
}

function object8(destruct, construct, field1, field2, field3, field4, field5, field6, field7, field8) {
  return {
          encode: (function (value) {
              var match = Curry._1(destruct, value);
              var keyVals = [
                encode$1(field1, match[0]),
                encode$1(field2, match[1]),
                encode$1(field3, match[2]),
                encode$1(field4, match[3]),
                encode$1(field5, match[4]),
                encode$1(field6, match[5]),
                encode$1(field7, match[6]),
                encode$1(field8, match[7])
              ];
              return Js_dict.fromArray(Belt_Array.concatMany(keyVals));
            }),
          decode: (function (json) {
              return Belt_Result.flatMap(asObject(json), (function (fieldset) {
                            var val1 = decode$1(field1, fieldset);
                            if (val1.TAG !== /* Ok */0) {
                              return val1;
                            }
                            var val2 = decode$1(field2, fieldset);
                            if (val2.TAG !== /* Ok */0) {
                              return val2;
                            }
                            var val3 = decode$1(field3, fieldset);
                            if (val3.TAG !== /* Ok */0) {
                              return val3;
                            }
                            var val4 = decode$1(field4, fieldset);
                            if (val4.TAG !== /* Ok */0) {
                              return val4;
                            }
                            var val5 = decode$1(field5, fieldset);
                            if (val5.TAG !== /* Ok */0) {
                              return val5;
                            }
                            var val6 = decode$1(field6, fieldset);
                            if (val6.TAG !== /* Ok */0) {
                              return val6;
                            }
                            var val7 = decode$1(field7, fieldset);
                            if (val7.TAG !== /* Ok */0) {
                              return val7;
                            }
                            var val8 = decode$1(field8, fieldset);
                            if (val8.TAG === /* Ok */0) {
                              return Curry._1(construct, [
                                          val1._0,
                                          val2._0,
                                          val3._0,
                                          val4._0,
                                          val5._0,
                                          val6._0,
                                          val7._0,
                                          val8._0
                                        ]);
                            } else {
                              return val8;
                            }
                          }));
            })
        };
}

function object9(destruct, construct, field1, field2, field3, field4, field5, field6, field7, field8, field9) {
  return {
          encode: (function (value) {
              var match = Curry._1(destruct, value);
              var keyVals = [
                encode$1(field1, match[0]),
                encode$1(field2, match[1]),
                encode$1(field3, match[2]),
                encode$1(field4, match[3]),
                encode$1(field5, match[4]),
                encode$1(field6, match[5]),
                encode$1(field7, match[6]),
                encode$1(field8, match[7]),
                encode$1(field9, match[8])
              ];
              return Js_dict.fromArray(Belt_Array.concatMany(keyVals));
            }),
          decode: (function (json) {
              return Belt_Result.flatMap(asObject(json), (function (fieldset) {
                            var val1 = decode$1(field1, fieldset);
                            if (val1.TAG !== /* Ok */0) {
                              return val1;
                            }
                            var val2 = decode$1(field2, fieldset);
                            if (val2.TAG !== /* Ok */0) {
                              return val2;
                            }
                            var val3 = decode$1(field3, fieldset);
                            if (val3.TAG !== /* Ok */0) {
                              return val3;
                            }
                            var val4 = decode$1(field4, fieldset);
                            if (val4.TAG !== /* Ok */0) {
                              return val4;
                            }
                            var val5 = decode$1(field5, fieldset);
                            if (val5.TAG !== /* Ok */0) {
                              return val5;
                            }
                            var val6 = decode$1(field6, fieldset);
                            if (val6.TAG !== /* Ok */0) {
                              return val6;
                            }
                            var val7 = decode$1(field7, fieldset);
                            if (val7.TAG !== /* Ok */0) {
                              return val7;
                            }
                            var val8 = decode$1(field8, fieldset);
                            if (val8.TAG !== /* Ok */0) {
                              return val8;
                            }
                            var val9 = decode$1(field9, fieldset);
                            if (val9.TAG === /* Ok */0) {
                              return Curry._1(construct, [
                                          val1._0,
                                          val2._0,
                                          val3._0,
                                          val4._0,
                                          val5._0,
                                          val6._0,
                                          val7._0,
                                          val8._0,
                                          val9._0
                                        ]);
                            } else {
                              return val9;
                            }
                          }));
            })
        };
}

function object10(destruct, construct, field1, field2, field3, field4, field5, field6, field7, field8, field9, field10) {
  return {
          encode: (function (value) {
              var match = Curry._1(destruct, value);
              var keyVals = [
                encode$1(field1, match[0]),
                encode$1(field2, match[1]),
                encode$1(field3, match[2]),
                encode$1(field4, match[3]),
                encode$1(field5, match[4]),
                encode$1(field6, match[5]),
                encode$1(field7, match[6]),
                encode$1(field8, match[7]),
                encode$1(field9, match[8]),
                encode$1(field10, match[9])
              ];
              return Js_dict.fromArray(Belt_Array.concatMany(keyVals));
            }),
          decode: (function (json) {
              return Belt_Result.flatMap(asObject(json), (function (fieldset) {
                            var val1 = decode$1(field1, fieldset);
                            if (val1.TAG !== /* Ok */0) {
                              return val1;
                            }
                            var val2 = decode$1(field2, fieldset);
                            if (val2.TAG !== /* Ok */0) {
                              return val2;
                            }
                            var val3 = decode$1(field3, fieldset);
                            if (val3.TAG !== /* Ok */0) {
                              return val3;
                            }
                            var val4 = decode$1(field4, fieldset);
                            if (val4.TAG !== /* Ok */0) {
                              return val4;
                            }
                            var val5 = decode$1(field5, fieldset);
                            if (val5.TAG !== /* Ok */0) {
                              return val5;
                            }
                            var val6 = decode$1(field6, fieldset);
                            if (val6.TAG !== /* Ok */0) {
                              return val6;
                            }
                            var val7 = decode$1(field7, fieldset);
                            if (val7.TAG !== /* Ok */0) {
                              return val7;
                            }
                            var val8 = decode$1(field8, fieldset);
                            if (val8.TAG !== /* Ok */0) {
                              return val8;
                            }
                            var val9 = decode$1(field9, fieldset);
                            if (val9.TAG !== /* Ok */0) {
                              return val9;
                            }
                            var val10 = decode$1(field10, fieldset);
                            if (val10.TAG === /* Ok */0) {
                              return Curry._1(construct, [
                                          val1._0,
                                          val2._0,
                                          val3._0,
                                          val4._0,
                                          val5._0,
                                          val6._0,
                                          val7._0,
                                          val8._0,
                                          val9._0,
                                          val10._0
                                        ]);
                            } else {
                              return val10;
                            }
                          }));
            })
        };
}

function object11(destruct, construct, field1, field2, field3, field4, field5, field6, field7, field8, field9, field10, field11) {
  return {
          encode: (function (value) {
              var match = Curry._1(destruct, value);
              var keyVals = [
                encode$1(field1, match[0]),
                encode$1(field2, match[1]),
                encode$1(field3, match[2]),
                encode$1(field4, match[3]),
                encode$1(field5, match[4]),
                encode$1(field6, match[5]),
                encode$1(field7, match[6]),
                encode$1(field8, match[7]),
                encode$1(field9, match[8]),
                encode$1(field10, match[9]),
                encode$1(field11, match[10])
              ];
              return Js_dict.fromArray(Belt_Array.concatMany(keyVals));
            }),
          decode: (function (json) {
              return Belt_Result.flatMap(asObject(json), (function (fieldset) {
                            var val1 = decode$1(field1, fieldset);
                            if (val1.TAG !== /* Ok */0) {
                              return val1;
                            }
                            var val2 = decode$1(field2, fieldset);
                            if (val2.TAG !== /* Ok */0) {
                              return val2;
                            }
                            var val3 = decode$1(field3, fieldset);
                            if (val3.TAG !== /* Ok */0) {
                              return val3;
                            }
                            var val4 = decode$1(field4, fieldset);
                            if (val4.TAG !== /* Ok */0) {
                              return val4;
                            }
                            var val5 = decode$1(field5, fieldset);
                            if (val5.TAG !== /* Ok */0) {
                              return val5;
                            }
                            var val6 = decode$1(field6, fieldset);
                            if (val6.TAG !== /* Ok */0) {
                              return val6;
                            }
                            var val7 = decode$1(field7, fieldset);
                            if (val7.TAG !== /* Ok */0) {
                              return val7;
                            }
                            var val8 = decode$1(field8, fieldset);
                            if (val8.TAG !== /* Ok */0) {
                              return val8;
                            }
                            var val9 = decode$1(field9, fieldset);
                            if (val9.TAG !== /* Ok */0) {
                              return val9;
                            }
                            var val10 = decode$1(field10, fieldset);
                            if (val10.TAG !== /* Ok */0) {
                              return val10;
                            }
                            var val11 = decode$1(field11, fieldset);
                            if (val11.TAG === /* Ok */0) {
                              return Curry._1(construct, [
                                          val1._0,
                                          val2._0,
                                          val3._0,
                                          val4._0,
                                          val5._0,
                                          val6._0,
                                          val7._0,
                                          val8._0,
                                          val9._0,
                                          val10._0,
                                          val11._0
                                        ]);
                            } else {
                              return val11;
                            }
                          }));
            })
        };
}

function object12(destruct, construct, field1, field2, field3, field4, field5, field6, field7, field8, field9, field10, field11, field12) {
  return {
          encode: (function (value) {
              var match = Curry._1(destruct, value);
              var keyVals = [
                encode$1(field1, match[0]),
                encode$1(field2, match[1]),
                encode$1(field3, match[2]),
                encode$1(field4, match[3]),
                encode$1(field5, match[4]),
                encode$1(field6, match[5]),
                encode$1(field7, match[6]),
                encode$1(field8, match[7]),
                encode$1(field9, match[8]),
                encode$1(field10, match[9]),
                encode$1(field11, match[10]),
                encode$1(field12, match[11])
              ];
              return Js_dict.fromArray(Belt_Array.concatMany(keyVals));
            }),
          decode: (function (json) {
              return Belt_Result.flatMap(asObject(json), (function (fieldset) {
                            var val1 = decode$1(field1, fieldset);
                            if (val1.TAG !== /* Ok */0) {
                              return val1;
                            }
                            var val2 = decode$1(field2, fieldset);
                            if (val2.TAG !== /* Ok */0) {
                              return val2;
                            }
                            var val3 = decode$1(field3, fieldset);
                            if (val3.TAG !== /* Ok */0) {
                              return val3;
                            }
                            var val4 = decode$1(field4, fieldset);
                            if (val4.TAG !== /* Ok */0) {
                              return val4;
                            }
                            var val5 = decode$1(field5, fieldset);
                            if (val5.TAG !== /* Ok */0) {
                              return val5;
                            }
                            var val6 = decode$1(field6, fieldset);
                            if (val6.TAG !== /* Ok */0) {
                              return val6;
                            }
                            var val7 = decode$1(field7, fieldset);
                            if (val7.TAG !== /* Ok */0) {
                              return val7;
                            }
                            var val8 = decode$1(field8, fieldset);
                            if (val8.TAG !== /* Ok */0) {
                              return val8;
                            }
                            var val9 = decode$1(field9, fieldset);
                            if (val9.TAG !== /* Ok */0) {
                              return val9;
                            }
                            var val10 = decode$1(field10, fieldset);
                            if (val10.TAG !== /* Ok */0) {
                              return val10;
                            }
                            var val11 = decode$1(field11, fieldset);
                            if (val11.TAG !== /* Ok */0) {
                              return val11;
                            }
                            var val12 = decode$1(field12, fieldset);
                            if (val12.TAG === /* Ok */0) {
                              return Curry._1(construct, [
                                          val1._0,
                                          val2._0,
                                          val3._0,
                                          val4._0,
                                          val5._0,
                                          val6._0,
                                          val7._0,
                                          val8._0,
                                          val9._0,
                                          val10._0,
                                          val11._0,
                                          val12._0
                                        ]);
                            } else {
                              return val12;
                            }
                          }));
            })
        };
}

function object13(destruct, construct, field1, field2, field3, field4, field5, field6, field7, field8, field9, field10, field11, field12, field13) {
  return {
          encode: (function (value) {
              var match = Curry._1(destruct, value);
              var keyVals = [
                encode$1(field1, match[0]),
                encode$1(field2, match[1]),
                encode$1(field3, match[2]),
                encode$1(field4, match[3]),
                encode$1(field5, match[4]),
                encode$1(field6, match[5]),
                encode$1(field7, match[6]),
                encode$1(field8, match[7]),
                encode$1(field9, match[8]),
                encode$1(field10, match[9]),
                encode$1(field11, match[10]),
                encode$1(field12, match[11]),
                encode$1(field13, match[12])
              ];
              return Js_dict.fromArray(Belt_Array.concatMany(keyVals));
            }),
          decode: (function (json) {
              return Belt_Result.flatMap(asObject(json), (function (fieldset) {
                            var val1 = decode$1(field1, fieldset);
                            if (val1.TAG !== /* Ok */0) {
                              return val1;
                            }
                            var val2 = decode$1(field2, fieldset);
                            if (val2.TAG !== /* Ok */0) {
                              return val2;
                            }
                            var val3 = decode$1(field3, fieldset);
                            if (val3.TAG !== /* Ok */0) {
                              return val3;
                            }
                            var val4 = decode$1(field4, fieldset);
                            if (val4.TAG !== /* Ok */0) {
                              return val4;
                            }
                            var val5 = decode$1(field5, fieldset);
                            if (val5.TAG !== /* Ok */0) {
                              return val5;
                            }
                            var val6 = decode$1(field6, fieldset);
                            if (val6.TAG !== /* Ok */0) {
                              return val6;
                            }
                            var val7 = decode$1(field7, fieldset);
                            if (val7.TAG !== /* Ok */0) {
                              return val7;
                            }
                            var val8 = decode$1(field8, fieldset);
                            if (val8.TAG !== /* Ok */0) {
                              return val8;
                            }
                            var val9 = decode$1(field9, fieldset);
                            if (val9.TAG !== /* Ok */0) {
                              return val9;
                            }
                            var val10 = decode$1(field10, fieldset);
                            if (val10.TAG !== /* Ok */0) {
                              return val10;
                            }
                            var val11 = decode$1(field11, fieldset);
                            if (val11.TAG !== /* Ok */0) {
                              return val11;
                            }
                            var val12 = decode$1(field12, fieldset);
                            if (val12.TAG !== /* Ok */0) {
                              return val12;
                            }
                            var val13 = decode$1(field13, fieldset);
                            if (val13.TAG === /* Ok */0) {
                              return Curry._1(construct, [
                                          val1._0,
                                          val2._0,
                                          val3._0,
                                          val4._0,
                                          val5._0,
                                          val6._0,
                                          val7._0,
                                          val8._0,
                                          val9._0,
                                          val10._0,
                                          val11._0,
                                          val12._0,
                                          val13._0
                                        ]);
                            } else {
                              return val13;
                            }
                          }));
            })
        };
}

function object14(destruct, construct, field1, field2, field3, field4, field5, field6, field7, field8, field9, field10, field11, field12, field13, field14) {
  return {
          encode: (function (value) {
              var match = Curry._1(destruct, value);
              var keyVals = [
                encode$1(field1, match[0]),
                encode$1(field2, match[1]),
                encode$1(field3, match[2]),
                encode$1(field4, match[3]),
                encode$1(field5, match[4]),
                encode$1(field6, match[5]),
                encode$1(field7, match[6]),
                encode$1(field8, match[7]),
                encode$1(field9, match[8]),
                encode$1(field10, match[9]),
                encode$1(field11, match[10]),
                encode$1(field12, match[11]),
                encode$1(field13, match[12]),
                encode$1(field14, match[13])
              ];
              return Js_dict.fromArray(Belt_Array.concatMany(keyVals));
            }),
          decode: (function (json) {
              return Belt_Result.flatMap(asObject(json), (function (fieldset) {
                            var val1 = decode$1(field1, fieldset);
                            if (val1.TAG !== /* Ok */0) {
                              return val1;
                            }
                            var val2 = decode$1(field2, fieldset);
                            if (val2.TAG !== /* Ok */0) {
                              return val2;
                            }
                            var val3 = decode$1(field3, fieldset);
                            if (val3.TAG !== /* Ok */0) {
                              return val3;
                            }
                            var val4 = decode$1(field4, fieldset);
                            if (val4.TAG !== /* Ok */0) {
                              return val4;
                            }
                            var val5 = decode$1(field5, fieldset);
                            if (val5.TAG !== /* Ok */0) {
                              return val5;
                            }
                            var val6 = decode$1(field6, fieldset);
                            if (val6.TAG !== /* Ok */0) {
                              return val6;
                            }
                            var val7 = decode$1(field7, fieldset);
                            if (val7.TAG !== /* Ok */0) {
                              return val7;
                            }
                            var val8 = decode$1(field8, fieldset);
                            if (val8.TAG !== /* Ok */0) {
                              return val8;
                            }
                            var val9 = decode$1(field9, fieldset);
                            if (val9.TAG !== /* Ok */0) {
                              return val9;
                            }
                            var val10 = decode$1(field10, fieldset);
                            if (val10.TAG !== /* Ok */0) {
                              return val10;
                            }
                            var val11 = decode$1(field11, fieldset);
                            if (val11.TAG !== /* Ok */0) {
                              return val11;
                            }
                            var val12 = decode$1(field12, fieldset);
                            if (val12.TAG !== /* Ok */0) {
                              return val12;
                            }
                            var val13 = decode$1(field13, fieldset);
                            if (val13.TAG !== /* Ok */0) {
                              return val13;
                            }
                            var val14 = decode$1(field14, fieldset);
                            if (val14.TAG === /* Ok */0) {
                              return Curry._1(construct, [
                                          val1._0,
                                          val2._0,
                                          val3._0,
                                          val4._0,
                                          val5._0,
                                          val6._0,
                                          val7._0,
                                          val8._0,
                                          val9._0,
                                          val10._0,
                                          val11._0,
                                          val12._0,
                                          val13._0,
                                          val14._0
                                        ]);
                            } else {
                              return val14;
                            }
                          }));
            })
        };
}

function object15(destruct, construct, field1, field2, field3, field4, field5, field6, field7, field8, field9, field10, field11, field12, field13, field14, field15) {
  return {
          encode: (function (value) {
              var match = Curry._1(destruct, value);
              var keyVals = [
                encode$1(field1, match[0]),
                encode$1(field2, match[1]),
                encode$1(field3, match[2]),
                encode$1(field4, match[3]),
                encode$1(field5, match[4]),
                encode$1(field6, match[5]),
                encode$1(field7, match[6]),
                encode$1(field8, match[7]),
                encode$1(field9, match[8]),
                encode$1(field10, match[9]),
                encode$1(field11, match[10]),
                encode$1(field12, match[11]),
                encode$1(field13, match[12]),
                encode$1(field14, match[13]),
                encode$1(field15, match[14])
              ];
              return Js_dict.fromArray(Belt_Array.concatMany(keyVals));
            }),
          decode: (function (json) {
              return Belt_Result.flatMap(asObject(json), (function (fieldset) {
                            var val1 = decode$1(field1, fieldset);
                            if (val1.TAG !== /* Ok */0) {
                              return val1;
                            }
                            var val2 = decode$1(field2, fieldset);
                            if (val2.TAG !== /* Ok */0) {
                              return val2;
                            }
                            var val3 = decode$1(field3, fieldset);
                            if (val3.TAG !== /* Ok */0) {
                              return val3;
                            }
                            var val4 = decode$1(field4, fieldset);
                            if (val4.TAG !== /* Ok */0) {
                              return val4;
                            }
                            var val5 = decode$1(field5, fieldset);
                            if (val5.TAG !== /* Ok */0) {
                              return val5;
                            }
                            var val6 = decode$1(field6, fieldset);
                            if (val6.TAG !== /* Ok */0) {
                              return val6;
                            }
                            var val7 = decode$1(field7, fieldset);
                            if (val7.TAG !== /* Ok */0) {
                              return val7;
                            }
                            var val8 = decode$1(field8, fieldset);
                            if (val8.TAG !== /* Ok */0) {
                              return val8;
                            }
                            var val9 = decode$1(field9, fieldset);
                            if (val9.TAG !== /* Ok */0) {
                              return val9;
                            }
                            var val10 = decode$1(field10, fieldset);
                            if (val10.TAG !== /* Ok */0) {
                              return val10;
                            }
                            var val11 = decode$1(field11, fieldset);
                            if (val11.TAG !== /* Ok */0) {
                              return val11;
                            }
                            var val12 = decode$1(field12, fieldset);
                            if (val12.TAG !== /* Ok */0) {
                              return val12;
                            }
                            var val13 = decode$1(field13, fieldset);
                            if (val13.TAG !== /* Ok */0) {
                              return val13;
                            }
                            var val14 = decode$1(field14, fieldset);
                            if (val14.TAG !== /* Ok */0) {
                              return val14;
                            }
                            var val15 = decode$1(field15, fieldset);
                            if (val15.TAG === /* Ok */0) {
                              return Curry._1(construct, [
                                          val1._0,
                                          val2._0,
                                          val3._0,
                                          val4._0,
                                          val5._0,
                                          val6._0,
                                          val7._0,
                                          val8._0,
                                          val9._0,
                                          val10._0,
                                          val11._0,
                                          val12._0,
                                          val13._0,
                                          val14._0,
                                          val15._0
                                        ]);
                            } else {
                              return val15;
                            }
                          }));
            })
        };
}

function object16(destruct, construct, field1, field2, field3, field4, field5, field6, field7, field8, field9, field10, field11, field12, field13, field14, field15, field16) {
  return {
          encode: (function (value) {
              var match = Curry._1(destruct, value);
              var keyVals = [
                encode$1(field1, match[0]),
                encode$1(field2, match[1]),
                encode$1(field3, match[2]),
                encode$1(field4, match[3]),
                encode$1(field5, match[4]),
                encode$1(field6, match[5]),
                encode$1(field7, match[6]),
                encode$1(field8, match[7]),
                encode$1(field9, match[8]),
                encode$1(field10, match[9]),
                encode$1(field11, match[10]),
                encode$1(field12, match[11]),
                encode$1(field13, match[12]),
                encode$1(field14, match[13]),
                encode$1(field15, match[14]),
                encode$1(field16, match[15])
              ];
              return Js_dict.fromArray(Belt_Array.concatMany(keyVals));
            }),
          decode: (function (json) {
              return Belt_Result.flatMap(asObject(json), (function (fieldset) {
                            var val1 = decode$1(field1, fieldset);
                            if (val1.TAG !== /* Ok */0) {
                              return val1;
                            }
                            var val2 = decode$1(field2, fieldset);
                            if (val2.TAG !== /* Ok */0) {
                              return val2;
                            }
                            var val3 = decode$1(field3, fieldset);
                            if (val3.TAG !== /* Ok */0) {
                              return val3;
                            }
                            var val4 = decode$1(field4, fieldset);
                            if (val4.TAG !== /* Ok */0) {
                              return val4;
                            }
                            var val5 = decode$1(field5, fieldset);
                            if (val5.TAG !== /* Ok */0) {
                              return val5;
                            }
                            var val6 = decode$1(field6, fieldset);
                            if (val6.TAG !== /* Ok */0) {
                              return val6;
                            }
                            var val7 = decode$1(field7, fieldset);
                            if (val7.TAG !== /* Ok */0) {
                              return val7;
                            }
                            var val8 = decode$1(field8, fieldset);
                            if (val8.TAG !== /* Ok */0) {
                              return val8;
                            }
                            var val9 = decode$1(field9, fieldset);
                            if (val9.TAG !== /* Ok */0) {
                              return val9;
                            }
                            var val10 = decode$1(field10, fieldset);
                            if (val10.TAG !== /* Ok */0) {
                              return val10;
                            }
                            var val11 = decode$1(field11, fieldset);
                            if (val11.TAG !== /* Ok */0) {
                              return val11;
                            }
                            var val12 = decode$1(field12, fieldset);
                            if (val12.TAG !== /* Ok */0) {
                              return val12;
                            }
                            var val13 = decode$1(field13, fieldset);
                            if (val13.TAG !== /* Ok */0) {
                              return val13;
                            }
                            var val14 = decode$1(field14, fieldset);
                            if (val14.TAG !== /* Ok */0) {
                              return val14;
                            }
                            var val15 = decode$1(field15, fieldset);
                            if (val15.TAG !== /* Ok */0) {
                              return val15;
                            }
                            var val16 = decode$1(field16, fieldset);
                            if (val16.TAG === /* Ok */0) {
                              return Curry._1(construct, [
                                          val1._0,
                                          val2._0,
                                          val3._0,
                                          val4._0,
                                          val5._0,
                                          val6._0,
                                          val7._0,
                                          val8._0,
                                          val9._0,
                                          val10._0,
                                          val11._0,
                                          val12._0,
                                          val13._0,
                                          val14._0,
                                          val15._0,
                                          val16._0
                                        ]);
                            } else {
                              return val16;
                            }
                          }));
            })
        };
}

function object17(destruct, construct, field1, field2, field3, field4, field5, field6, field7, field8, field9, field10, field11, field12, field13, field14, field15, field16, field17) {
  return {
          encode: (function (value) {
              var match = Curry._1(destruct, value);
              var keyVals = [
                encode$1(field1, match[0]),
                encode$1(field2, match[1]),
                encode$1(field3, match[2]),
                encode$1(field4, match[3]),
                encode$1(field5, match[4]),
                encode$1(field6, match[5]),
                encode$1(field7, match[6]),
                encode$1(field8, match[7]),
                encode$1(field9, match[8]),
                encode$1(field10, match[9]),
                encode$1(field11, match[10]),
                encode$1(field12, match[11]),
                encode$1(field13, match[12]),
                encode$1(field14, match[13]),
                encode$1(field15, match[14]),
                encode$1(field16, match[15]),
                encode$1(field17, match[16])
              ];
              return Js_dict.fromArray(Belt_Array.concatMany(keyVals));
            }),
          decode: (function (json) {
              return Belt_Result.flatMap(asObject(json), (function (fieldset) {
                            var val1 = decode$1(field1, fieldset);
                            if (val1.TAG !== /* Ok */0) {
                              return val1;
                            }
                            var val2 = decode$1(field2, fieldset);
                            if (val2.TAG !== /* Ok */0) {
                              return val2;
                            }
                            var val3 = decode$1(field3, fieldset);
                            if (val3.TAG !== /* Ok */0) {
                              return val3;
                            }
                            var val4 = decode$1(field4, fieldset);
                            if (val4.TAG !== /* Ok */0) {
                              return val4;
                            }
                            var val5 = decode$1(field5, fieldset);
                            if (val5.TAG !== /* Ok */0) {
                              return val5;
                            }
                            var val6 = decode$1(field6, fieldset);
                            if (val6.TAG !== /* Ok */0) {
                              return val6;
                            }
                            var val7 = decode$1(field7, fieldset);
                            if (val7.TAG !== /* Ok */0) {
                              return val7;
                            }
                            var val8 = decode$1(field8, fieldset);
                            if (val8.TAG !== /* Ok */0) {
                              return val8;
                            }
                            var val9 = decode$1(field9, fieldset);
                            if (val9.TAG !== /* Ok */0) {
                              return val9;
                            }
                            var val10 = decode$1(field10, fieldset);
                            if (val10.TAG !== /* Ok */0) {
                              return val10;
                            }
                            var val11 = decode$1(field11, fieldset);
                            if (val11.TAG !== /* Ok */0) {
                              return val11;
                            }
                            var val12 = decode$1(field12, fieldset);
                            if (val12.TAG !== /* Ok */0) {
                              return val12;
                            }
                            var val13 = decode$1(field13, fieldset);
                            if (val13.TAG !== /* Ok */0) {
                              return val13;
                            }
                            var val14 = decode$1(field14, fieldset);
                            if (val14.TAG !== /* Ok */0) {
                              return val14;
                            }
                            var val15 = decode$1(field15, fieldset);
                            if (val15.TAG !== /* Ok */0) {
                              return val15;
                            }
                            var val16 = decode$1(field16, fieldset);
                            if (val16.TAG !== /* Ok */0) {
                              return val16;
                            }
                            var val17 = decode$1(field17, fieldset);
                            if (val17.TAG === /* Ok */0) {
                              return Curry._1(construct, [
                                          val1._0,
                                          val2._0,
                                          val3._0,
                                          val4._0,
                                          val5._0,
                                          val6._0,
                                          val7._0,
                                          val8._0,
                                          val9._0,
                                          val10._0,
                                          val11._0,
                                          val12._0,
                                          val13._0,
                                          val14._0,
                                          val15._0,
                                          val16._0,
                                          val17._0
                                        ]);
                            } else {
                              return val17;
                            }
                          }));
            })
        };
}

function object18(destruct, construct, field1, field2, field3, field4, field5, field6, field7, field8, field9, field10, field11, field12, field13, field14, field15, field16, field17, field18) {
  return {
          encode: (function (value) {
              var match = Curry._1(destruct, value);
              var keyVals = [
                encode$1(field1, match[0]),
                encode$1(field2, match[1]),
                encode$1(field3, match[2]),
                encode$1(field4, match[3]),
                encode$1(field5, match[4]),
                encode$1(field6, match[5]),
                encode$1(field7, match[6]),
                encode$1(field8, match[7]),
                encode$1(field9, match[8]),
                encode$1(field10, match[9]),
                encode$1(field11, match[10]),
                encode$1(field12, match[11]),
                encode$1(field13, match[12]),
                encode$1(field14, match[13]),
                encode$1(field15, match[14]),
                encode$1(field16, match[15]),
                encode$1(field17, match[16]),
                encode$1(field18, match[17])
              ];
              return Js_dict.fromArray(Belt_Array.concatMany(keyVals));
            }),
          decode: (function (json) {
              return Belt_Result.flatMap(asObject(json), (function (fieldset) {
                            var val1 = decode$1(field1, fieldset);
                            if (val1.TAG !== /* Ok */0) {
                              return val1;
                            }
                            var val2 = decode$1(field2, fieldset);
                            if (val2.TAG !== /* Ok */0) {
                              return val2;
                            }
                            var val3 = decode$1(field3, fieldset);
                            if (val3.TAG !== /* Ok */0) {
                              return val3;
                            }
                            var val4 = decode$1(field4, fieldset);
                            if (val4.TAG !== /* Ok */0) {
                              return val4;
                            }
                            var val5 = decode$1(field5, fieldset);
                            if (val5.TAG !== /* Ok */0) {
                              return val5;
                            }
                            var val6 = decode$1(field6, fieldset);
                            if (val6.TAG !== /* Ok */0) {
                              return val6;
                            }
                            var val7 = decode$1(field7, fieldset);
                            if (val7.TAG !== /* Ok */0) {
                              return val7;
                            }
                            var val8 = decode$1(field8, fieldset);
                            if (val8.TAG !== /* Ok */0) {
                              return val8;
                            }
                            var val9 = decode$1(field9, fieldset);
                            if (val9.TAG !== /* Ok */0) {
                              return val9;
                            }
                            var val10 = decode$1(field10, fieldset);
                            if (val10.TAG !== /* Ok */0) {
                              return val10;
                            }
                            var val11 = decode$1(field11, fieldset);
                            if (val11.TAG !== /* Ok */0) {
                              return val11;
                            }
                            var val12 = decode$1(field12, fieldset);
                            if (val12.TAG !== /* Ok */0) {
                              return val12;
                            }
                            var val13 = decode$1(field13, fieldset);
                            if (val13.TAG !== /* Ok */0) {
                              return val13;
                            }
                            var val14 = decode$1(field14, fieldset);
                            if (val14.TAG !== /* Ok */0) {
                              return val14;
                            }
                            var val15 = decode$1(field15, fieldset);
                            if (val15.TAG !== /* Ok */0) {
                              return val15;
                            }
                            var val16 = decode$1(field16, fieldset);
                            if (val16.TAG !== /* Ok */0) {
                              return val16;
                            }
                            var val17 = decode$1(field17, fieldset);
                            if (val17.TAG !== /* Ok */0) {
                              return val17;
                            }
                            var val18 = decode$1(field18, fieldset);
                            if (val18.TAG === /* Ok */0) {
                              return Curry._1(construct, [
                                          val1._0,
                                          val2._0,
                                          val3._0,
                                          val4._0,
                                          val5._0,
                                          val6._0,
                                          val7._0,
                                          val8._0,
                                          val9._0,
                                          val10._0,
                                          val11._0,
                                          val12._0,
                                          val13._0,
                                          val14._0,
                                          val15._0,
                                          val16._0,
                                          val17._0,
                                          val18._0
                                        ]);
                            } else {
                              return val18;
                            }
                          }));
            })
        };
}

function object19(destruct, construct, field1, field2, field3, field4, field5, field6, field7, field8, field9, field10, field11, field12, field13, field14, field15, field16, field17, field18, field19) {
  return {
          encode: (function (value) {
              var match = Curry._1(destruct, value);
              var keyVals = [
                encode$1(field1, match[0]),
                encode$1(field2, match[1]),
                encode$1(field3, match[2]),
                encode$1(field4, match[3]),
                encode$1(field5, match[4]),
                encode$1(field6, match[5]),
                encode$1(field7, match[6]),
                encode$1(field8, match[7]),
                encode$1(field9, match[8]),
                encode$1(field10, match[9]),
                encode$1(field11, match[10]),
                encode$1(field12, match[11]),
                encode$1(field13, match[12]),
                encode$1(field14, match[13]),
                encode$1(field15, match[14]),
                encode$1(field16, match[15]),
                encode$1(field17, match[16]),
                encode$1(field18, match[17]),
                encode$1(field19, match[18])
              ];
              return Js_dict.fromArray(Belt_Array.concatMany(keyVals));
            }),
          decode: (function (json) {
              return Belt_Result.flatMap(asObject(json), (function (fieldset) {
                            var val1 = decode$1(field1, fieldset);
                            if (val1.TAG !== /* Ok */0) {
                              return val1;
                            }
                            var val2 = decode$1(field2, fieldset);
                            if (val2.TAG !== /* Ok */0) {
                              return val2;
                            }
                            var val3 = decode$1(field3, fieldset);
                            if (val3.TAG !== /* Ok */0) {
                              return val3;
                            }
                            var val4 = decode$1(field4, fieldset);
                            if (val4.TAG !== /* Ok */0) {
                              return val4;
                            }
                            var val5 = decode$1(field5, fieldset);
                            if (val5.TAG !== /* Ok */0) {
                              return val5;
                            }
                            var val6 = decode$1(field6, fieldset);
                            if (val6.TAG !== /* Ok */0) {
                              return val6;
                            }
                            var val7 = decode$1(field7, fieldset);
                            if (val7.TAG !== /* Ok */0) {
                              return val7;
                            }
                            var val8 = decode$1(field8, fieldset);
                            if (val8.TAG !== /* Ok */0) {
                              return val8;
                            }
                            var val9 = decode$1(field9, fieldset);
                            if (val9.TAG !== /* Ok */0) {
                              return val9;
                            }
                            var val10 = decode$1(field10, fieldset);
                            if (val10.TAG !== /* Ok */0) {
                              return val10;
                            }
                            var val11 = decode$1(field11, fieldset);
                            if (val11.TAG !== /* Ok */0) {
                              return val11;
                            }
                            var val12 = decode$1(field12, fieldset);
                            if (val12.TAG !== /* Ok */0) {
                              return val12;
                            }
                            var val13 = decode$1(field13, fieldset);
                            if (val13.TAG !== /* Ok */0) {
                              return val13;
                            }
                            var val14 = decode$1(field14, fieldset);
                            if (val14.TAG !== /* Ok */0) {
                              return val14;
                            }
                            var val15 = decode$1(field15, fieldset);
                            if (val15.TAG !== /* Ok */0) {
                              return val15;
                            }
                            var val16 = decode$1(field16, fieldset);
                            if (val16.TAG !== /* Ok */0) {
                              return val16;
                            }
                            var val17 = decode$1(field17, fieldset);
                            if (val17.TAG !== /* Ok */0) {
                              return val17;
                            }
                            var val18 = decode$1(field18, fieldset);
                            if (val18.TAG !== /* Ok */0) {
                              return val18;
                            }
                            var val19 = decode$1(field19, fieldset);
                            if (val19.TAG === /* Ok */0) {
                              return Curry._1(construct, [
                                          val1._0,
                                          val2._0,
                                          val3._0,
                                          val4._0,
                                          val5._0,
                                          val6._0,
                                          val7._0,
                                          val8._0,
                                          val9._0,
                                          val10._0,
                                          val11._0,
                                          val12._0,
                                          val13._0,
                                          val14._0,
                                          val15._0,
                                          val16._0,
                                          val17._0,
                                          val18._0,
                                          val19._0
                                        ]);
                            } else {
                              return val19;
                            }
                          }));
            })
        };
}

function object20(destruct, construct, field1, field2, field3, field4, field5, field6, field7, field8, field9, field10, field11, field12, field13, field14, field15, field16, field17, field18, field19, field20) {
  return {
          encode: (function (value) {
              var match = Curry._1(destruct, value);
              var keyVals = [
                encode$1(field1, match[0]),
                encode$1(field2, match[1]),
                encode$1(field3, match[2]),
                encode$1(field4, match[3]),
                encode$1(field5, match[4]),
                encode$1(field6, match[5]),
                encode$1(field7, match[6]),
                encode$1(field8, match[7]),
                encode$1(field9, match[8]),
                encode$1(field10, match[9]),
                encode$1(field11, match[10]),
                encode$1(field12, match[11]),
                encode$1(field13, match[12]),
                encode$1(field14, match[13]),
                encode$1(field15, match[14]),
                encode$1(field16, match[15]),
                encode$1(field17, match[16]),
                encode$1(field18, match[17]),
                encode$1(field19, match[18]),
                encode$1(field20, match[19])
              ];
              return Js_dict.fromArray(Belt_Array.concatMany(keyVals));
            }),
          decode: (function (json) {
              return Belt_Result.flatMap(asObject(json), (function (fieldset) {
                            var val1 = decode$1(field1, fieldset);
                            if (val1.TAG !== /* Ok */0) {
                              return val1;
                            }
                            var val2 = decode$1(field2, fieldset);
                            if (val2.TAG !== /* Ok */0) {
                              return val2;
                            }
                            var val3 = decode$1(field3, fieldset);
                            if (val3.TAG !== /* Ok */0) {
                              return val3;
                            }
                            var val4 = decode$1(field4, fieldset);
                            if (val4.TAG !== /* Ok */0) {
                              return val4;
                            }
                            var val5 = decode$1(field5, fieldset);
                            if (val5.TAG !== /* Ok */0) {
                              return val5;
                            }
                            var val6 = decode$1(field6, fieldset);
                            if (val6.TAG !== /* Ok */0) {
                              return val6;
                            }
                            var val7 = decode$1(field7, fieldset);
                            if (val7.TAG !== /* Ok */0) {
                              return val7;
                            }
                            var val8 = decode$1(field8, fieldset);
                            if (val8.TAG !== /* Ok */0) {
                              return val8;
                            }
                            var val9 = decode$1(field9, fieldset);
                            if (val9.TAG !== /* Ok */0) {
                              return val9;
                            }
                            var val10 = decode$1(field10, fieldset);
                            if (val10.TAG !== /* Ok */0) {
                              return val10;
                            }
                            var val11 = decode$1(field11, fieldset);
                            if (val11.TAG !== /* Ok */0) {
                              return val11;
                            }
                            var val12 = decode$1(field12, fieldset);
                            if (val12.TAG !== /* Ok */0) {
                              return val12;
                            }
                            var val13 = decode$1(field13, fieldset);
                            if (val13.TAG !== /* Ok */0) {
                              return val13;
                            }
                            var val14 = decode$1(field14, fieldset);
                            if (val14.TAG !== /* Ok */0) {
                              return val14;
                            }
                            var val15 = decode$1(field15, fieldset);
                            if (val15.TAG !== /* Ok */0) {
                              return val15;
                            }
                            var val16 = decode$1(field16, fieldset);
                            if (val16.TAG !== /* Ok */0) {
                              return val16;
                            }
                            var val17 = decode$1(field17, fieldset);
                            if (val17.TAG !== /* Ok */0) {
                              return val17;
                            }
                            var val18 = decode$1(field18, fieldset);
                            if (val18.TAG !== /* Ok */0) {
                              return val18;
                            }
                            var val19 = decode$1(field19, fieldset);
                            if (val19.TAG !== /* Ok */0) {
                              return val19;
                            }
                            var val20 = decode$1(field20, fieldset);
                            if (val20.TAG === /* Ok */0) {
                              return Curry._1(construct, [
                                          val1._0,
                                          val2._0,
                                          val3._0,
                                          val4._0,
                                          val5._0,
                                          val6._0,
                                          val7._0,
                                          val8._0,
                                          val9._0,
                                          val10._0,
                                          val11._0,
                                          val12._0,
                                          val13._0,
                                          val14._0,
                                          val15._0,
                                          val16._0,
                                          val17._0,
                                          val18._0,
                                          val19._0,
                                          val20._0
                                        ]);
                            } else {
                              return val20;
                            }
                          }));
            })
        };
}

function object21(destruct, construct, field1, field2, field3, field4, field5, field6, field7, field8, field9, field10, field11, field12, field13, field14, field15, field16, field17, field18, field19, field20, field21) {
  return {
          encode: (function (value) {
              var match = Curry._1(destruct, value);
              var keyVals = [
                encode$1(field1, match[0]),
                encode$1(field2, match[1]),
                encode$1(field3, match[2]),
                encode$1(field4, match[3]),
                encode$1(field5, match[4]),
                encode$1(field6, match[5]),
                encode$1(field7, match[6]),
                encode$1(field8, match[7]),
                encode$1(field9, match[8]),
                encode$1(field10, match[9]),
                encode$1(field11, match[10]),
                encode$1(field12, match[11]),
                encode$1(field13, match[12]),
                encode$1(field14, match[13]),
                encode$1(field15, match[14]),
                encode$1(field16, match[15]),
                encode$1(field17, match[16]),
                encode$1(field18, match[17]),
                encode$1(field19, match[18]),
                encode$1(field20, match[19]),
                encode$1(field21, match[20])
              ];
              return Js_dict.fromArray(Belt_Array.concatMany(keyVals));
            }),
          decode: (function (json) {
              return Belt_Result.flatMap(asObject(json), (function (fieldset) {
                            var val1 = decode$1(field1, fieldset);
                            if (val1.TAG !== /* Ok */0) {
                              return val1;
                            }
                            var val2 = decode$1(field2, fieldset);
                            if (val2.TAG !== /* Ok */0) {
                              return val2;
                            }
                            var val3 = decode$1(field3, fieldset);
                            if (val3.TAG !== /* Ok */0) {
                              return val3;
                            }
                            var val4 = decode$1(field4, fieldset);
                            if (val4.TAG !== /* Ok */0) {
                              return val4;
                            }
                            var val5 = decode$1(field5, fieldset);
                            if (val5.TAG !== /* Ok */0) {
                              return val5;
                            }
                            var val6 = decode$1(field6, fieldset);
                            if (val6.TAG !== /* Ok */0) {
                              return val6;
                            }
                            var val7 = decode$1(field7, fieldset);
                            if (val7.TAG !== /* Ok */0) {
                              return val7;
                            }
                            var val8 = decode$1(field8, fieldset);
                            if (val8.TAG !== /* Ok */0) {
                              return val8;
                            }
                            var val9 = decode$1(field9, fieldset);
                            if (val9.TAG !== /* Ok */0) {
                              return val9;
                            }
                            var val10 = decode$1(field10, fieldset);
                            if (val10.TAG !== /* Ok */0) {
                              return val10;
                            }
                            var val11 = decode$1(field11, fieldset);
                            if (val11.TAG !== /* Ok */0) {
                              return val11;
                            }
                            var val12 = decode$1(field12, fieldset);
                            if (val12.TAG !== /* Ok */0) {
                              return val12;
                            }
                            var val13 = decode$1(field13, fieldset);
                            if (val13.TAG !== /* Ok */0) {
                              return val13;
                            }
                            var val14 = decode$1(field14, fieldset);
                            if (val14.TAG !== /* Ok */0) {
                              return val14;
                            }
                            var val15 = decode$1(field15, fieldset);
                            if (val15.TAG !== /* Ok */0) {
                              return val15;
                            }
                            var val16 = decode$1(field16, fieldset);
                            if (val16.TAG !== /* Ok */0) {
                              return val16;
                            }
                            var val17 = decode$1(field17, fieldset);
                            if (val17.TAG !== /* Ok */0) {
                              return val17;
                            }
                            var val18 = decode$1(field18, fieldset);
                            if (val18.TAG !== /* Ok */0) {
                              return val18;
                            }
                            var val19 = decode$1(field19, fieldset);
                            if (val19.TAG !== /* Ok */0) {
                              return val19;
                            }
                            var val20 = decode$1(field20, fieldset);
                            if (val20.TAG !== /* Ok */0) {
                              return val20;
                            }
                            var val21 = decode$1(field21, fieldset);
                            if (val21.TAG === /* Ok */0) {
                              return Curry._1(construct, [
                                          val1._0,
                                          val2._0,
                                          val3._0,
                                          val4._0,
                                          val5._0,
                                          val6._0,
                                          val7._0,
                                          val8._0,
                                          val9._0,
                                          val10._0,
                                          val11._0,
                                          val12._0,
                                          val13._0,
                                          val14._0,
                                          val15._0,
                                          val16._0,
                                          val17._0,
                                          val18._0,
                                          val19._0,
                                          val20._0,
                                          val21._0
                                        ]);
                            } else {
                              return val21;
                            }
                          }));
            })
        };
}

function object22(destruct, construct, field1, field2, field3, field4, field5, field6, field7, field8, field9, field10, field11, field12, field13, field14, field15, field16, field17, field18, field19, field20, field21, field22) {
  return {
          encode: (function (value) {
              var match = Curry._1(destruct, value);
              var keyVals = [
                encode$1(field1, match[0]),
                encode$1(field2, match[1]),
                encode$1(field3, match[2]),
                encode$1(field4, match[3]),
                encode$1(field5, match[4]),
                encode$1(field6, match[5]),
                encode$1(field7, match[6]),
                encode$1(field8, match[7]),
                encode$1(field9, match[8]),
                encode$1(field10, match[9]),
                encode$1(field11, match[10]),
                encode$1(field12, match[11]),
                encode$1(field13, match[12]),
                encode$1(field14, match[13]),
                encode$1(field15, match[14]),
                encode$1(field16, match[15]),
                encode$1(field17, match[16]),
                encode$1(field18, match[17]),
                encode$1(field19, match[18]),
                encode$1(field20, match[19]),
                encode$1(field21, match[20]),
                encode$1(field22, match[21])
              ];
              return Js_dict.fromArray(Belt_Array.concatMany(keyVals));
            }),
          decode: (function (json) {
              return Belt_Result.flatMap(asObject(json), (function (fieldset) {
                            var val1 = decode$1(field1, fieldset);
                            if (val1.TAG !== /* Ok */0) {
                              return val1;
                            }
                            var val2 = decode$1(field2, fieldset);
                            if (val2.TAG !== /* Ok */0) {
                              return val2;
                            }
                            var val3 = decode$1(field3, fieldset);
                            if (val3.TAG !== /* Ok */0) {
                              return val3;
                            }
                            var val4 = decode$1(field4, fieldset);
                            if (val4.TAG !== /* Ok */0) {
                              return val4;
                            }
                            var val5 = decode$1(field5, fieldset);
                            if (val5.TAG !== /* Ok */0) {
                              return val5;
                            }
                            var val6 = decode$1(field6, fieldset);
                            if (val6.TAG !== /* Ok */0) {
                              return val6;
                            }
                            var val7 = decode$1(field7, fieldset);
                            if (val7.TAG !== /* Ok */0) {
                              return val7;
                            }
                            var val8 = decode$1(field8, fieldset);
                            if (val8.TAG !== /* Ok */0) {
                              return val8;
                            }
                            var val9 = decode$1(field9, fieldset);
                            if (val9.TAG !== /* Ok */0) {
                              return val9;
                            }
                            var val10 = decode$1(field10, fieldset);
                            if (val10.TAG !== /* Ok */0) {
                              return val10;
                            }
                            var val11 = decode$1(field11, fieldset);
                            if (val11.TAG !== /* Ok */0) {
                              return val11;
                            }
                            var val12 = decode$1(field12, fieldset);
                            if (val12.TAG !== /* Ok */0) {
                              return val12;
                            }
                            var val13 = decode$1(field13, fieldset);
                            if (val13.TAG !== /* Ok */0) {
                              return val13;
                            }
                            var val14 = decode$1(field14, fieldset);
                            if (val14.TAG !== /* Ok */0) {
                              return val14;
                            }
                            var val15 = decode$1(field15, fieldset);
                            if (val15.TAG !== /* Ok */0) {
                              return val15;
                            }
                            var val16 = decode$1(field16, fieldset);
                            if (val16.TAG !== /* Ok */0) {
                              return val16;
                            }
                            var val17 = decode$1(field17, fieldset);
                            if (val17.TAG !== /* Ok */0) {
                              return val17;
                            }
                            var val18 = decode$1(field18, fieldset);
                            if (val18.TAG !== /* Ok */0) {
                              return val18;
                            }
                            var val19 = decode$1(field19, fieldset);
                            if (val19.TAG !== /* Ok */0) {
                              return val19;
                            }
                            var val20 = decode$1(field20, fieldset);
                            if (val20.TAG !== /* Ok */0) {
                              return val20;
                            }
                            var val21 = decode$1(field21, fieldset);
                            if (val21.TAG !== /* Ok */0) {
                              return val21;
                            }
                            var val22 = decode$1(field22, fieldset);
                            if (val22.TAG === /* Ok */0) {
                              return Curry._1(construct, [
                                          val1._0,
                                          val2._0,
                                          val3._0,
                                          val4._0,
                                          val5._0,
                                          val6._0,
                                          val7._0,
                                          val8._0,
                                          val9._0,
                                          val10._0,
                                          val11._0,
                                          val12._0,
                                          val13._0,
                                          val14._0,
                                          val15._0,
                                          val16._0,
                                          val17._0,
                                          val18._0,
                                          val19._0,
                                          val20._0,
                                          val21._0,
                                          val22._0
                                        ]);
                            } else {
                              return val22;
                            }
                          }));
            })
        };
}

function object23(destruct, construct, field1, field2, field3, field4, field5, field6, field7, field8, field9, field10, field11, field12, field13, field14, field15, field16, field17, field18, field19, field20, field21, field22, field23) {
  return {
          encode: (function (value) {
              var match = Curry._1(destruct, value);
              var keyVals = [
                encode$1(field1, match[0]),
                encode$1(field2, match[1]),
                encode$1(field3, match[2]),
                encode$1(field4, match[3]),
                encode$1(field5, match[4]),
                encode$1(field6, match[5]),
                encode$1(field7, match[6]),
                encode$1(field8, match[7]),
                encode$1(field9, match[8]),
                encode$1(field10, match[9]),
                encode$1(field11, match[10]),
                encode$1(field12, match[11]),
                encode$1(field13, match[12]),
                encode$1(field14, match[13]),
                encode$1(field15, match[14]),
                encode$1(field16, match[15]),
                encode$1(field17, match[16]),
                encode$1(field18, match[17]),
                encode$1(field19, match[18]),
                encode$1(field20, match[19]),
                encode$1(field21, match[20]),
                encode$1(field22, match[21]),
                encode$1(field23, match[22])
              ];
              return Js_dict.fromArray(Belt_Array.concatMany(keyVals));
            }),
          decode: (function (json) {
              return Belt_Result.flatMap(asObject(json), (function (fieldset) {
                            var val1 = decode$1(field1, fieldset);
                            if (val1.TAG !== /* Ok */0) {
                              return val1;
                            }
                            var val2 = decode$1(field2, fieldset);
                            if (val2.TAG !== /* Ok */0) {
                              return val2;
                            }
                            var val3 = decode$1(field3, fieldset);
                            if (val3.TAG !== /* Ok */0) {
                              return val3;
                            }
                            var val4 = decode$1(field4, fieldset);
                            if (val4.TAG !== /* Ok */0) {
                              return val4;
                            }
                            var val5 = decode$1(field5, fieldset);
                            if (val5.TAG !== /* Ok */0) {
                              return val5;
                            }
                            var val6 = decode$1(field6, fieldset);
                            if (val6.TAG !== /* Ok */0) {
                              return val6;
                            }
                            var val7 = decode$1(field7, fieldset);
                            if (val7.TAG !== /* Ok */0) {
                              return val7;
                            }
                            var val8 = decode$1(field8, fieldset);
                            if (val8.TAG !== /* Ok */0) {
                              return val8;
                            }
                            var val9 = decode$1(field9, fieldset);
                            if (val9.TAG !== /* Ok */0) {
                              return val9;
                            }
                            var val10 = decode$1(field10, fieldset);
                            if (val10.TAG !== /* Ok */0) {
                              return val10;
                            }
                            var val11 = decode$1(field11, fieldset);
                            if (val11.TAG !== /* Ok */0) {
                              return val11;
                            }
                            var val12 = decode$1(field12, fieldset);
                            if (val12.TAG !== /* Ok */0) {
                              return val12;
                            }
                            var val13 = decode$1(field13, fieldset);
                            if (val13.TAG !== /* Ok */0) {
                              return val13;
                            }
                            var val14 = decode$1(field14, fieldset);
                            if (val14.TAG !== /* Ok */0) {
                              return val14;
                            }
                            var val15 = decode$1(field15, fieldset);
                            if (val15.TAG !== /* Ok */0) {
                              return val15;
                            }
                            var val16 = decode$1(field16, fieldset);
                            if (val16.TAG !== /* Ok */0) {
                              return val16;
                            }
                            var val17 = decode$1(field17, fieldset);
                            if (val17.TAG !== /* Ok */0) {
                              return val17;
                            }
                            var val18 = decode$1(field18, fieldset);
                            if (val18.TAG !== /* Ok */0) {
                              return val18;
                            }
                            var val19 = decode$1(field19, fieldset);
                            if (val19.TAG !== /* Ok */0) {
                              return val19;
                            }
                            var val20 = decode$1(field20, fieldset);
                            if (val20.TAG !== /* Ok */0) {
                              return val20;
                            }
                            var val21 = decode$1(field21, fieldset);
                            if (val21.TAG !== /* Ok */0) {
                              return val21;
                            }
                            var val22 = decode$1(field22, fieldset);
                            if (val22.TAG !== /* Ok */0) {
                              return val22;
                            }
                            var val23 = decode$1(field23, fieldset);
                            if (val23.TAG === /* Ok */0) {
                              return Curry._1(construct, [
                                          val1._0,
                                          val2._0,
                                          val3._0,
                                          val4._0,
                                          val5._0,
                                          val6._0,
                                          val7._0,
                                          val8._0,
                                          val9._0,
                                          val10._0,
                                          val11._0,
                                          val12._0,
                                          val13._0,
                                          val14._0,
                                          val15._0,
                                          val16._0,
                                          val17._0,
                                          val18._0,
                                          val19._0,
                                          val20._0,
                                          val21._0,
                                          val22._0,
                                          val23._0
                                        ]);
                            } else {
                              return val23;
                            }
                          }));
            })
        };
}

function object24(destruct, construct, field1, field2, field3, field4, field5, field6, field7, field8, field9, field10, field11, field12, field13, field14, field15, field16, field17, field18, field19, field20, field21, field22, field23, field24) {
  return {
          encode: (function (value) {
              var match = Curry._1(destruct, value);
              var keyVals = [
                encode$1(field1, match[0]),
                encode$1(field2, match[1]),
                encode$1(field3, match[2]),
                encode$1(field4, match[3]),
                encode$1(field5, match[4]),
                encode$1(field6, match[5]),
                encode$1(field7, match[6]),
                encode$1(field8, match[7]),
                encode$1(field9, match[8]),
                encode$1(field10, match[9]),
                encode$1(field11, match[10]),
                encode$1(field12, match[11]),
                encode$1(field13, match[12]),
                encode$1(field14, match[13]),
                encode$1(field15, match[14]),
                encode$1(field16, match[15]),
                encode$1(field17, match[16]),
                encode$1(field18, match[17]),
                encode$1(field19, match[18]),
                encode$1(field20, match[19]),
                encode$1(field21, match[20]),
                encode$1(field22, match[21]),
                encode$1(field23, match[22]),
                encode$1(field24, match[23])
              ];
              return Js_dict.fromArray(Belt_Array.concatMany(keyVals));
            }),
          decode: (function (json) {
              return Belt_Result.flatMap(asObject(json), (function (fieldset) {
                            var val1 = decode$1(field1, fieldset);
                            if (val1.TAG !== /* Ok */0) {
                              return val1;
                            }
                            var val2 = decode$1(field2, fieldset);
                            if (val2.TAG !== /* Ok */0) {
                              return val2;
                            }
                            var val3 = decode$1(field3, fieldset);
                            if (val3.TAG !== /* Ok */0) {
                              return val3;
                            }
                            var val4 = decode$1(field4, fieldset);
                            if (val4.TAG !== /* Ok */0) {
                              return val4;
                            }
                            var val5 = decode$1(field5, fieldset);
                            if (val5.TAG !== /* Ok */0) {
                              return val5;
                            }
                            var val6 = decode$1(field6, fieldset);
                            if (val6.TAG !== /* Ok */0) {
                              return val6;
                            }
                            var val7 = decode$1(field7, fieldset);
                            if (val7.TAG !== /* Ok */0) {
                              return val7;
                            }
                            var val8 = decode$1(field8, fieldset);
                            if (val8.TAG !== /* Ok */0) {
                              return val8;
                            }
                            var val9 = decode$1(field9, fieldset);
                            if (val9.TAG !== /* Ok */0) {
                              return val9;
                            }
                            var val10 = decode$1(field10, fieldset);
                            if (val10.TAG !== /* Ok */0) {
                              return val10;
                            }
                            var val11 = decode$1(field11, fieldset);
                            if (val11.TAG !== /* Ok */0) {
                              return val11;
                            }
                            var val12 = decode$1(field12, fieldset);
                            if (val12.TAG !== /* Ok */0) {
                              return val12;
                            }
                            var val13 = decode$1(field13, fieldset);
                            if (val13.TAG !== /* Ok */0) {
                              return val13;
                            }
                            var val14 = decode$1(field14, fieldset);
                            if (val14.TAG !== /* Ok */0) {
                              return val14;
                            }
                            var val15 = decode$1(field15, fieldset);
                            if (val15.TAG !== /* Ok */0) {
                              return val15;
                            }
                            var val16 = decode$1(field16, fieldset);
                            if (val16.TAG !== /* Ok */0) {
                              return val16;
                            }
                            var val17 = decode$1(field17, fieldset);
                            if (val17.TAG !== /* Ok */0) {
                              return val17;
                            }
                            var val18 = decode$1(field18, fieldset);
                            if (val18.TAG !== /* Ok */0) {
                              return val18;
                            }
                            var val19 = decode$1(field19, fieldset);
                            if (val19.TAG !== /* Ok */0) {
                              return val19;
                            }
                            var val20 = decode$1(field20, fieldset);
                            if (val20.TAG !== /* Ok */0) {
                              return val20;
                            }
                            var val21 = decode$1(field21, fieldset);
                            if (val21.TAG !== /* Ok */0) {
                              return val21;
                            }
                            var val22 = decode$1(field22, fieldset);
                            if (val22.TAG !== /* Ok */0) {
                              return val22;
                            }
                            var val23 = decode$1(field23, fieldset);
                            if (val23.TAG !== /* Ok */0) {
                              return val23;
                            }
                            var val24 = decode$1(field24, fieldset);
                            if (val24.TAG === /* Ok */0) {
                              return Curry._1(construct, [
                                          val1._0,
                                          val2._0,
                                          val3._0,
                                          val4._0,
                                          val5._0,
                                          val6._0,
                                          val7._0,
                                          val8._0,
                                          val9._0,
                                          val10._0,
                                          val11._0,
                                          val12._0,
                                          val13._0,
                                          val14._0,
                                          val15._0,
                                          val16._0,
                                          val17._0,
                                          val18._0,
                                          val19._0,
                                          val20._0,
                                          val21._0,
                                          val22._0,
                                          val23._0,
                                          val24._0
                                        ]);
                            } else {
                              return val24;
                            }
                          }));
            })
        };
}

function object25(destruct, construct, field1, field2, field3, field4, field5, field6, field7, field8, field9, field10, field11, field12, field13, field14, field15, field16, field17, field18, field19, field20, field21, field22, field23, field24, field25) {
  return {
          encode: (function (value) {
              var match = Curry._1(destruct, value);
              var keyVals = [
                encode$1(field1, match[0]),
                encode$1(field2, match[1]),
                encode$1(field3, match[2]),
                encode$1(field4, match[3]),
                encode$1(field5, match[4]),
                encode$1(field6, match[5]),
                encode$1(field7, match[6]),
                encode$1(field8, match[7]),
                encode$1(field9, match[8]),
                encode$1(field10, match[9]),
                encode$1(field11, match[10]),
                encode$1(field12, match[11]),
                encode$1(field13, match[12]),
                encode$1(field14, match[13]),
                encode$1(field15, match[14]),
                encode$1(field16, match[15]),
                encode$1(field17, match[16]),
                encode$1(field18, match[17]),
                encode$1(field19, match[18]),
                encode$1(field20, match[19]),
                encode$1(field21, match[20]),
                encode$1(field22, match[21]),
                encode$1(field23, match[22]),
                encode$1(field24, match[23]),
                encode$1(field25, match[24])
              ];
              return Js_dict.fromArray(Belt_Array.concatMany(keyVals));
            }),
          decode: (function (json) {
              return Belt_Result.flatMap(asObject(json), (function (fieldset) {
                            var val1 = decode$1(field1, fieldset);
                            if (val1.TAG !== /* Ok */0) {
                              return val1;
                            }
                            var val2 = decode$1(field2, fieldset);
                            if (val2.TAG !== /* Ok */0) {
                              return val2;
                            }
                            var val3 = decode$1(field3, fieldset);
                            if (val3.TAG !== /* Ok */0) {
                              return val3;
                            }
                            var val4 = decode$1(field4, fieldset);
                            if (val4.TAG !== /* Ok */0) {
                              return val4;
                            }
                            var val5 = decode$1(field5, fieldset);
                            if (val5.TAG !== /* Ok */0) {
                              return val5;
                            }
                            var val6 = decode$1(field6, fieldset);
                            if (val6.TAG !== /* Ok */0) {
                              return val6;
                            }
                            var val7 = decode$1(field7, fieldset);
                            if (val7.TAG !== /* Ok */0) {
                              return val7;
                            }
                            var val8 = decode$1(field8, fieldset);
                            if (val8.TAG !== /* Ok */0) {
                              return val8;
                            }
                            var val9 = decode$1(field9, fieldset);
                            if (val9.TAG !== /* Ok */0) {
                              return val9;
                            }
                            var val10 = decode$1(field10, fieldset);
                            if (val10.TAG !== /* Ok */0) {
                              return val10;
                            }
                            var val11 = decode$1(field11, fieldset);
                            if (val11.TAG !== /* Ok */0) {
                              return val11;
                            }
                            var val12 = decode$1(field12, fieldset);
                            if (val12.TAG !== /* Ok */0) {
                              return val12;
                            }
                            var val13 = decode$1(field13, fieldset);
                            if (val13.TAG !== /* Ok */0) {
                              return val13;
                            }
                            var val14 = decode$1(field14, fieldset);
                            if (val14.TAG !== /* Ok */0) {
                              return val14;
                            }
                            var val15 = decode$1(field15, fieldset);
                            if (val15.TAG !== /* Ok */0) {
                              return val15;
                            }
                            var val16 = decode$1(field16, fieldset);
                            if (val16.TAG !== /* Ok */0) {
                              return val16;
                            }
                            var val17 = decode$1(field17, fieldset);
                            if (val17.TAG !== /* Ok */0) {
                              return val17;
                            }
                            var val18 = decode$1(field18, fieldset);
                            if (val18.TAG !== /* Ok */0) {
                              return val18;
                            }
                            var val19 = decode$1(field19, fieldset);
                            if (val19.TAG !== /* Ok */0) {
                              return val19;
                            }
                            var val20 = decode$1(field20, fieldset);
                            if (val20.TAG !== /* Ok */0) {
                              return val20;
                            }
                            var val21 = decode$1(field21, fieldset);
                            if (val21.TAG !== /* Ok */0) {
                              return val21;
                            }
                            var val22 = decode$1(field22, fieldset);
                            if (val22.TAG !== /* Ok */0) {
                              return val22;
                            }
                            var val23 = decode$1(field23, fieldset);
                            if (val23.TAG !== /* Ok */0) {
                              return val23;
                            }
                            var val24 = decode$1(field24, fieldset);
                            if (val24.TAG !== /* Ok */0) {
                              return val24;
                            }
                            var val25 = decode$1(field25, fieldset);
                            if (val25.TAG === /* Ok */0) {
                              return Curry._1(construct, [
                                          val1._0,
                                          val2._0,
                                          val3._0,
                                          val4._0,
                                          val5._0,
                                          val6._0,
                                          val7._0,
                                          val8._0,
                                          val9._0,
                                          val10._0,
                                          val11._0,
                                          val12._0,
                                          val13._0,
                                          val14._0,
                                          val15._0,
                                          val16._0,
                                          val17._0,
                                          val18._0,
                                          val19._0,
                                          val20._0,
                                          val21._0,
                                          val22._0,
                                          val23._0,
                                          val24._0,
                                          val25._0
                                        ]);
                            } else {
                              return val25;
                            }
                          }));
            })
        };
}

var DecodingError = {
  prependLocation: prependLocation,
  toString: toString
};

var custom = make;

var json = identity;

var optional = makeOptional;

var $$default = assignDefault;

export {
  DecodingError ,
  decode ,
  decodeWith ,
  decodeString ,
  decodeStringWith ,
  encode ,
  encodeWith ,
  encodeString ,
  encodeStringWith ,
  custom ,
  string ,
  $$float ,
  $$int ,
  bool ,
  json ,
  nullable ,
  nullAs ,
  array ,
  dict ,
  field ,
  self ,
  optional ,
  $$default ,
  $$default as default,
  asObject ,
  object1 ,
  object2 ,
  object3 ,
  object4 ,
  object5 ,
  object6 ,
  object7 ,
  object8 ,
  object9 ,
  object10 ,
  object11 ,
  object12 ,
  object13 ,
  object14 ,
  object15 ,
  object16 ,
  object17 ,
  object18 ,
  object19 ,
  object20 ,
  object21 ,
  object22 ,
  object23 ,
  object24 ,
  object25 ,
  
}
/* No side effect */
